import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { clearPortalAuthStorage, recallLoginSSO } from './loginUtils';

let isSetup = false;

export function setupAuthInterceptor() {
  if (isSetup) return;
  isSetup = true;

  axios.interceptors.response.use(
    (res) => res,
    async (error) => {
      const status = error.response?.status;
      const config = error.config;

      // Only handle 401/403; skip auth endpoints and already-retried requests
      const isAuthUrl =
        config?.url?.includes('/auth/local/login') ||
        config?.url?.includes('/auth/sso/callback') ||
        config?.url?.includes('/auth/sso/login');

      if ((status !== 401 && status !== 403) || config?._retry || isAuthUrl) {
        return Promise.reject(error);
      }

      config._retry = true;

      // One retry — catches transient auth failures
      try {
        return await axios(config);
      } catch (retryErr) {
        const retryStatus = retryErr.response?.status;

        if (retryStatus === 401) {
          enqueueSnackbar('Sitzung abgelaufen – bitte neu anmelden.', {
            variant: 'error',
            preventDuplicate: true,
            autoHideDuration: 4000,
          });

          setTimeout(() => {
            const provider = localStorage.getItem('provider');
            if (provider === 'sso') {
              recallLoginSSO(retryStatus);
            } else {
              clearPortalAuthStorage();
              window.location.href = '/auth/login';
            }
          }, 1500);
        } else if (retryStatus === 403) {
          enqueueSnackbar('Keine Berechtigung für diese Aktion.', {
            variant: 'warning',
            preventDuplicate: true,
            autoHideDuration: 4000,
          });
        }

        return Promise.reject(retryErr);
      }
    }
  );
}
